export default "__VITE_ASSET__1oFZZ2rg__"